export const statusModalConstants = {
    OPEN: 'STATUS_MODAL_OPEN',
    CLOSE: 'STATUS_MODAL_CLOSE',
};
